<template>
  <StackLayout class="wrapper">
    <AgCard modal :caption="title">
      <StackLayout class="card-content">
        <Label class="text" :text="message" textWrap />
        <AgButton v-if="button && action" outlined :text="button" @tap="action" @click="action" />
        <AgButton text="Schließen" @tap="close" @click="close" />
      </StackLayout>
    </AgCard>
  </StackLayout>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '[title]'
    },
    message: {
      type: String,
      default: '[message]'
    },
    button: {
      type: String
    },
    action: {
      type: Function
    }
  },
  methods: {
    close () {
      this.$emit('done')
    }
  }
}

</script>